module.exports = __webpack_public_path__ + "static/media/arrow.4e8d963c.svg";